<template>
  
  <div class="t">

    
        <div class="myCenter">  

            <h2 class=" text-red-700 myClassTitle full font-extrabold">
            <!-- {{this.mySlot.start_time.substring(0, this.mySlot.start_time.lastIndexOf(':'))}} -->
            {{mySlot.class.name}}
            </h2>

        </div>

    <div class="flex flex-col lg:flex-row items-center justify-around h-full pb-3 text-grey-dark pt-2 lg:me-24">

        <div class="flex sm:flex-row mt-2">

            <div class="myOverlayText myFullCenter">            
                <span class="font-bold mr-1 lg:mr-4">{{$t('slot.start')}}</span>

                <h2 class=" text-red-700">
                <!-- {{this.mySlot.start_time.substring(0, this.mySlot.start_time.lastIndexOf(':'))}} -->
                {{startTime}}
                </h2>
            </div>

            <div class="myOverlayText myFullCenter">

                
                <span class="font-bold mr-1 lg:mr-4">{{$t('sessions.duration')}} </span>

                <h2 class="text-pink-800">
                    {{getDuration()}}
                    </h2>
            </div>
            
            <div class="myOverlayText myFullCenter">
                    
                <span class="font-bold">{{$t('classes.level')}} </span>

                <h2 class="text-pink-700">{{mySlot.class.level}}</h2>
            </div>

            <div class="myOverlayText myFullCenter">
                    
                    <span class="font-bold">{{$t('sessions.available')}} </span>

                    <h2 class="text-pink-700">{{available}}</h2>
                </div>
        
            <!-- <div class="myOverlayText myFullCenter">
                
                <span class="font-bold mr-1 lg:mr-4">
                        {{$t('slot.endTime')}}
                                
                </span>
                    

                <h2 class="text-pink-700">{{endTime}}</h2>
            </div>             -->

            <!-- <div class="myOverlayText myFullCenter overflow-y-scroll">
                <h3 class="text-black font-extrabold font-sans" >
                <p class="text-pink-800">{{$t('classes.type')}}</p>
                 <p class="border-pink-800 border-2 lg:border-4 rounded-full"></p>{{type}}</h3>
            </div> -->
        </div> 


        <div class="flex lg:flex-col flex-row mt-2">

            <div class="flex flex-row pb-1 lg:pb-3 text-grey-dark">

                <div v-if="mySlot.pay_cash" class="myOverlayText myFullCenter" :class="{'bg-green-500': !paymentByPoints}"
                @click.stop.prevent="paymentByPoints = false">
                    
                    <span class="font-bold">{{$t('classes.cash')}} </span>

                     <h2 v-if="isUserGymSubscribed ">{{$t('memberships.free')}}</h2>
                    <h2 v-else-if="isUserStudioSubscribed ">{{$t('memberships.inPackage')}}</h2>
                    <h2  v-else class="text-pink-700">{{mySlot.cash_cost}}</h2>
                </div>
                
                <div v-if="mySlot.pay_points" class="myOverlayText myFullCenter" :class="{'bg-green-500': paymentByPoints}"
                @click.stop.prevent="paymentByPoints = true">
                    
                    <span class="font-bold">{{$t('classes.points')}} </span>

                    <h2 v-if="isUserGymSubscribed ">{{$t('memberships.free')}}</h2>
                    <h2 v-else-if="isUserStudioSubscribed ">{{$t('memberships.inPackage')}}</h2>
                    <h2 v-else class="text-pink-700">{{mySlot.points_cost}}</h2>
                </div>

                <div class="lg:border-r">

                </div>


            </div>
        </div>

        <div class="flex text-center text-sm w-full">

            <div class="ms-2 myCenter text-center"> 

                <div v-if="isSubscribed()" class="mySubscribedOverlayText myFullCenter">
                        
                    <h4  
                    class="font-bold lg:font-extrabold font-sans text-white">
                    <p class="lg:w-32">{{$t('memberships.member')}}</p></h4>
                </div> 

                <div class="myMixedOverlayText myFullCenter">
                        
                    <h4 v-if="mySlot.males && mySlot.females" class="font-bold lg:font-extrabold font-sans text-white">
                    <p class="lg:w-32">{{$t('sessions.mixed')}}</p></h4>

                    <h4 v-else  class="font-bold lg:font-extrabold font-sans text-white lg:rounded">
                    <p class="w-24 text-xs">{{$t('sessions.notMixed')}}</p></h4>
                </div> 

                <div v-if="mySlot.class.business.is_private == true" class="myPrivateOverlayText myFullCenter">
                        
                    <h4  
                    class=" font-bold lg:font-extrabold font-sans text-white">
                    <p class="w-20 lg:w-32">{{$t('sessions.private')}}</p></h4>
                </div>
            </div>    

            <div  v-if="!booked" class="ms-2 lg:ms-20">

                <button class="mycardBorder myBookButton" @click.stop.prevent="callBooking">

                    <label v-if="isUserGymSubscribed">{{$t('memberships.join')}}</label>
                    <label v-if="isUserStudioSubscribed">{{$t('memberships.register')}}</label>

                    <label v-else>{{$t('sessions.book')}}</label>                    
                </button>
            </div>                                

            <div class="ms-20 lg:ms-20 w-20 myCenter2" v-else>

                <label v-if="isUserGymSubscribed" class="myBookedText"> {{$t('sessions.booked')}}</label>
                <label v-if="isUserStudioSubscribed" class="myBookedText"> {{$t('sessions.booked')}}</label>

                <label v-else class="myBookedText"> {{$t('sessions.booked')}}</label>

            </div> 
            </div>     
        </div>
    </div>        
</template>


<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';

import myUpdates from '../../hasura/myUpdates';

import componentsHelpers from '../../classes/componentHelpers';

import cardImagesComponent from '../cards-components/CardImages'
import cardDetailsComponent from '../cards-components/SessionsDetails'

import { createPopper } from '@popperjs/core';

export default {

    created(){

            // console.log(`slot: ${JSON.stringify(this.slot)}`);

            // console.log(`is button disabled: ${this.disablePage}`);

        // console.log(`index: ${this.index} start_time is: ${(this.slot.start_time.substring(this.slot.start_time.lastIndexOf(':')))}`);

        // console.log(`image is: ${JSON.stringify(this.slot.class.image_1)}`);

        if(this.mySlot.instructor_name != ''){

            this.instructorName = this.mySlot.instructor_name;
        }

        else if(this.mySlot.class.instructor_name != ''){

            this.instructorName = this.mySlot.class.instructor_name;
        }
        else if(this.mySlot.class.instructor.name != ''){

            this.instructorName = this.mySlot.class.instructor.name;
        }
        
        // console.log(`bookings in this mySlot: ${JSON.stringify(this.mySlot)}`);

        // console.log(`UserId: ${this.userId} and dayDate: ${this.dayDate}`);

        this.setType();
    },

    mounted(){
        
        if(!this.mySlot.pay_points){
            
            this.paymentByPoints = false;
        }
        // console.log(`mySlot: ${JSON.stringify(this.mySlot)}`);

        // console.log(`mySlot: ${JSON.stringify(this.mySlot.bookings_counts)}`);

        this.isBgGreen = true;
        // console.log(`mySlot : ${JSON.stringify(this.mySlot)}`);

        // console.log(`business: ${JSON.stringify(this.mySlot.class.business.is_private)}`);

        const dayDate = this.dayDate;

        const bookingsCounts = this.mySlot.bookings_counts.filter(item => item.booking_day_date == dayDate);

        if(bookingsCounts.length > 0){

            this.available = this.mySlot.capacity - bookingsCounts[0].registered;
        }

    },

    props: {


        booked: false,
        
        disablePage: false,

        disableButton: false,

        isOnline: false,

        userId: 0,

        dayDate: '',

        mySlot:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        makeCardBooked: {

            type: Function
        },

        myReload: {

            type: Function
        },

        index: 0,

        book: {
            
            type: Function
        },

        cancelBooking: {

            type: Function
        },

        changeCardView: {

            type: Function
        },


        displayModal: {

            type: Function
        },
    },

    components:{

        RingLoader,
        cardImagesComponent,
        cardDetailsComponent
    },

    methods:{

        isSubscribed(){

            if(this.isGymSubscribed()){

                this.isUserGymSubscribed = true;
                return true;
            }else if(this.isStudioSubscribed()){

                this.isUserStudioSubscribed = true;
                return true;
            }else{

                return false;
            }
        },

        isGymSubscribed(){

            for (let i = 0; i < this.mySlot.class.business.three_gym_memberships.length; i++){
            
                const membership = this.mySlot.class.business.three_gym_memberships[i];

                if(membership.include_classes == true){

                    for(let j = 0; j < membership.three_user_gym_memberships.length; j++)
                    {
            
                        const membershipUser = membership.three_user_gym_memberships[j];
                        const todayDate = moment(new Date()).format(moment.HTML5_FMT.DATE);

                        if(moment(membershipUser.start_date).isSameOrBefore(todayDate)
                         && moment(membershipUser.end_date).isSameOrAfter(todayDate)){

                             if(this.userId == membershipUser.user_id){

                                return true;
                             }
                        }
                    }
                }
            }
            
            return false;
        },

        isStudioSubscribed(){

            for (let i = 0; i < this.mySlot.class.business.three_studio_memberships.length; i++){
            
                const membership = this.mySlot.class.business.three_studio_memberships[i];

                if(membership.include_classes == true){

                    for(let j = 0; j < membership.three_user_studio_memberships.length; j++)
                    {
            
                        const membershipUser = membership.three_user_studio_memberships[j];
                        const todayDate = moment(new Date()).format(moment.HTML5_FMT.DATE);

                        if(moment(membershipUser.start_date).isSameOrBefore(todayDate)
                         && moment(membershipUser.end_date).isSameOrAfter(todayDate)){

                             if(this.userId == membershipUser.user_id){

                                return true;
                             }
                        }
                    }
                }
            }
            
            return false;
        },
  
        toastIt(){

            const subOptions =  { 	 theme: "toasted-primary", position: "bottom-center", duration : 5000,
             keepOnHover: true, singleton:true };
            this.$toasted.clear();
            this.$toasted.info(this.mySlot.class.description, subOptions);
        },

        showDescription(){


        },

        closePop(){

            this.popoverShow = false;
        },

        resetColor(){

            // console.log(`myclass is:${JSON.stringify(this.slot.class)}`);

            // this.$refs.slotInfoRef.style.backgroundColor = "#fff5f5";

            // if(this.slot.class.is_online == true)
            
            // {
            // console.log(`online slot is ${this.slot.class.name}`);

            //     this.$refs.slotInfoRef.style.backgroundColor="#81e6d9";
            // }
            // else{
            //                 // console.log(`not True color`);


            //     this.$refs.slotInfoRef.style.backgroundColor= "#fff5f5";
            // }
        },  

        getDuration(){

            // console.log(`index:${this.index} start time is: ${new Date('1970-01-01T' + this.mySlot.start_time  + 'Z')}`)
            let minutes = ((new Date('1970/01/01 ' + this.mySlot.end_time  + '') - new Date('1970/01/01 ' + this.mySlot.start_time  + ' '))/ (1000*60));

            if(minutes > 720){

                minutes = minutes - 720;
            }
            
            let retainValue = function (value) {
                return Number.parseFloat(value).toPrecision(2);
            };
            moment.relativeTimeRounding(retainValue);

            const duration = moment.duration({"minutes": minutes}).humanize();
            // const duration = moment.duration({"minutes": minutes}).humanize(true);

            // console.log(`duration is ${duration}`);

            return duration;
        },
 

        setType(){
            
            const types = this.mySlot.class.categories;

            for(let i = 0; i < types.length; i++){

                if(i != types.length - 1){
                    
                    this.type = this.type + types[i].category.name + ', '
                }
                else {
                  
                  this.type = this.type + types[i].category.name;
                }
            }
            // console.log(`type is ${this.type}`);
            return this.type;
        },  

        callBooking(){

            if(this.disableButton == true) 
            {

                return;
            }

            if(this.disablePage == true){

                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.yourProfileeIsNotComplete'), 1, 'bubble', true);
                return;
            }
            
            const bookingSuccessful = this.bookingSuccessful;

            if(this.booked){

                if(this.bookingId == 0){

                    componentsHelpers.toastIt(this.$toasted, this.$t('payment.somethingWentWrong'), 1, 'bubble', true);
                }
                else if(confirm(this.$t('sessions.cancelBooking'))){

                    this.loading = true;
                    this.cancelBooking(this.mySlot, this.bookingId, this.index, bookingSuccessful);
                }
            }
            else if(confirm(this.$t('sessions.confirmBooking'))){

                this.loading = true;


                this.book(this.mySlot, this.index, bookingSuccessful, this.isUserGymSubscribed, this.isUserStudioSubscribed, this.paymentByPoints);
            }
        },


        bookingSuccessful(value){

            // return;
            
            this.loading = false;
            
            if(value == true){

                this.makeCardBooked();
                    
                if(this.available > 0){

                    this.available = this.available - 1;
                }
                            // this.isBgGreen = true;

                    // this.$forceUpdate();
                    // hconsole.log(`inside true`);
                // this.$refs.slotInfoRef.style.backgroundColor = "#48bb78";
            }
            else{
                    // console.log(`inside false`);
                    // this.isBgGreen = false;
                    // this.$forceUpdate();

                // this.$refs.slotInfoRef.style.backgroundColor = "#bee3f8";
            }
        },

        changeView(isMaximize, index){

            this.changeCardView(isMaximize, index);
        }
    },

  data: function(){

    return{

        paymentByPoints: true,
        loading:false,
        myDayDate: this.dayDate,
        startTime: moment(new Date(`1970/01/01 ${this.mySlot.start_time}`)).format('hh:mm A'),
        endTime: moment(new Date(`1970/01/01 ${this.mySlot.end_time}`)).format('hh:mm A'),
        isMaximize: true,
        bookingId: 0,
        instructorName: '',
        filteredSlots: [],
        weekDays: '',
        edit: false,
        initiated: false, 
        type: '',   
        available: this.mySlot.capacity,
        popoverShow:false,
        isUserGymSubscribed: false,
        isUserStudioSubscribed: false,


        points: 0,
        payCash: false,
        payPoints: true,
        capacity: 0,

        days: [7],
        isBgGreen: false


    }
  },

}
</script>

<style>

</style>
